import customerIdRegex from '@eneco/common/validation/customerIdRegex';
import phoneNumberRegex from '@eneco/common/validation/phoneNumberRegex';
import * as yup from 'yup';

import type { HeatDamageFormFields } from '../heat-damage-form-content.types';

export const getSchema = (formFields: HeatDamageFormFields) =>
  yup.object({
    recaptchaToken: yup.string().required(),
    isHomeOwner: yup.bool().required(formFields.isHomeOwnerFormField.requiredMessage),
    description: yup.string().required(formFields.descriptionFormField.requiredMessage),
    insurer: yup.string(),
    estimatedDamage: yup.string(),
    salutation: yup.string().required(formFields.salutationFormField.requiredMessage),
    firstname: yup.string().required(formFields.firstNameFormField.requiredMessage),
    surnamePreposition: yup.string(),
    surname: yup.string().required(formFields.surnameFormField.requiredMessage),
    street: yup.string().required(formFields.streetNameFormField.requiredMessage),
    houseNumber: yup.string().required(formFields.houseNumberFormField.requiredMessage),
    postalCode: yup.string().required(formFields.postalCodeFormField.requiredMessage),
    city: yup.string().required(formFields.cityFormField.requiredMessage),
    phoneNumber: yup
      .string()
      .matches(phoneNumberRegex, {
        excludeEmptyString: true,
        message: formFields.phoneNumberFormField.validationMessage,
      })
      .required(formFields.phoneNumberFormField.requiredMessage),
    email: yup
      .string()
      .email(formFields.emailFormField.validationMessage)
      .required(formFields.emailFormField.requiredMessage),
    customerId: yup
      .string()
      .required(formFields.customerIdFormField.requiredMessage)
      .matches(customerIdRegex, formFields.customerIdFormField.validationMessage),
    remarks: yup.string(),
  });
